import { render, staticRenderFns } from "./PublicGallery.vue?vue&type=template&id=3b2e23fe&scoped=true&"
import script from "./PublicGallery.vue?vue&type=script&lang=js&"
export * from "./PublicGallery.vue?vue&type=script&lang=js&"
import style0 from "./PublicGallery.vue?vue&type=style&index=0&id=3b2e23fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e23fe",
  null
  
)

export default component.exports